export const MENU_ITEMS = [
  {
    name: 'Order',
    hasSubmenu: false,
    path: '/orders',
    relatedPaths: ['orders', 'orderdetail'],
  },
  {
    name: 'Product',
    hasSubmenu: false,
    path: '/products',
    relatedPaths: ['products', 'product', '/product/create'],
  },
  {
    name: 'Category',
    hasSubmenu: true,
    path: '/categories',
    relatedPaths: ['categories'],
    submenu: [
      {
        name: 'Artist',
        path: '/artist',
      },
      { name: 'Categories', path: '/categories' },
    ],
  },
  {
    name: 'User',
    hasSubmenu: false,
    path: '/users',
    relatedPaths: ['user'],
  },
  {
    name: 'Keyword',
    hasSubmenu: false,
    path: '/keywords',
    relatedPaths: ['keywords'],
  },
  {
    name: 'Contact',
    hasSubmenu: false,
    path: '/contacts',
    relatedPaths: ['contacts'],
  },
  {
    name: 'Pending Approval',
    hasSubmenu: false,
    path: '/pending-approval',
    relatedPaths: ['pending-approval'],
  },
];
